import { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import {
  Col,
  Row,
} from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { VzPageContainer } from "../../../../layouts/VzPageContainer";
import ServerSideDataTable from "../../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import {
  getCustomerDataReport,
} from "./CustomerDataReportActions";
const CustomerDataReport = (props) => {
    const { id } = useParams();
  /* ---------------- table state ---------------- */
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);

  /* ---------------- helpers ---------------- */
  const formRequestObject = (isExport = false) => {
    let requestData = {
      id: id,
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText || null,
      isExport: isExport,
    };
    return requestData;
  };

  const fetchList = () => {
    props.getCustomerDataReport(formRequestObject());
  };
  useEffect(() => {

    if (id)
      fetchList();
  }, [id, searchText, currentPageNo, currentPageSize]);

  useEffect(() => {
      setTotalRecords(props.report?.totalRecords || 0);
  }, [props.report]);

  /* ---------------- table ---------------- */
  const columns = [
    { Header: "VIZ ID", accessor: "vizId" },
    { Header: "Shop Name", accessor: "shopId" },
    { Header: "CNIC", accessor: "cnic" },
    { Header: "Mobile No", accessor: "mobileNo" },
    { Header: "Full Name", accessor: "fullName" },
    { Header: "Email", accessor: "email" },
    { Header: "Status", accessor: "status" },
  ];

 
  /***********************/

   return (
    <VzPageContainer title="Shop Transactional Data Report > Customer Data Report">
    <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>Customer Data Report</b>
            </h4>
            <br />
          </Col>
         
        </Row>
      <Row>
        <Col>
          <ServerSideDataTable
            data={props.report?.data ?? []}
            columns={columns}
            totalRecords={totalRecords}
            pageNo={currentPageNo}
            myPageSize={currentPageSize}
            goToNextPage={setCurrentPageNo}
            goToPreviousPage={setCurrentPageNo}
            pageSizeChange={setCurrentPageSize}
            searchChanged={setSearchText}
          />
        </Col>
      </Row>
    </VzPageContainer>
  );
};

const mapStateToProps = (state) => ({
  report: state.CustomerDataReport,
});

export default connect(mapStateToProps, {
  getCustomerDataReport,
})(CustomerDataReport);
